<template>
  <div class="hello">
    <h1 @click="getImageBase64">{{ msg }}</h1>
    <img id="testImg" width="300px" height="350px" :src="imageBase64Data" alt=""/>
    <h2>Essential Links</h2>
    <div class="home-content-search">
      <form class="home-content-search-form">
        <input class="search" type="submit" value="搜索" @click="searchClick">
      </form>
    </div>
    <ul>
      <li>
        <a
          href="https://vuejs.org"
          target="_blank"
        >
          Core Docs
        </a>
      </li>
      <li>
        <a
          href="https://forum.vuejs.org"
          target="_blank"
        >
          Forum
        </a>
      </li>
      <li>
        <a
          href="https://chat.vuejs.org"
          target="_blank"
        >
          Community Chat
        </a>
      </li>
      <li>
        <a
          href="https://twitter.com/vuejs"
          target="_blank"
        >
          Twitter
        </a>
      </li>
      <br>
      <li>
        <a
          href="http://vuejs-templates.github.io/webpack/"
          target="_blank"
        >
          Docs for This Template
        </a>
      </li>
    </ul>
    <h2>Ecosystem</h2>
    <ul>
      <li>
        <a
          href="http://router.vuejs.org/"
          target="_blank"
        >
          vue-router
        </a>
      </li>
      <li>
        <a
          href="http://vuex.vuejs.org/"
          target="_blank"
        >
          vuex
        </a>
      </li>
      <li>
        <a
          href="http://vue-loader.vuejs.org/"
          target="_blank"
        >
          vue-loader
        </a>
      </li>
      <li>
        <a
          href="https://github.com/vuejs/awesome-vue"
          target="_blank"
        >
          awesome-vue
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      imageBase64Data: ''
    }
  },
  methods: {
    getImageBase64: function () {
      window.URL = window.URL || window.webkitURL;
      var p = window.location.protocol;
      var imageUrl = 'http://blog-qn.xueyuhuihui.com/ssl.png';
      console.log(p, imageUrl,'-pp');
      var base64 = '';
      var x = new  XMLHttpRequest();
      x.open("get", imageUrl, true);
      x.responseType = "blob";
      x.onload = function(){
        debugger;
        if (this.status == 200){
          var blob = this.response;
          console.log("blob", blob);
          let fileReader = new FileReader();
          fileReader.onloadend = function (e) {
            base64 = e.target.result;
            console.log('base64', base64);
          }
          fileReader.readAsDataURL(blob);
          let src = window.URL.createObjectURL(blob);
          var img = document.getElementById("testImg");
          img.src = src;
        }
      }
      x.send();
      this.imageBase64Data = base64;
      console.log('imageBase64Data', this.imageBase64Data);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
 .hello .home-content-search .home-content-search-form .search {
  /*background: url("./../assets/back_1.png");*//*radial-gradient(50% 50%, rgba(0, 225, 255, 1) 0%, rgba(0, 225, 255, 0.01) 100%);*/
  /*box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);*/
  border-radius: 5px;
  /*background: radial-gradient(16px 16px at 16px 16px, rgba(0, 225, 255, 1) 0%, rgba(0, 225, 255, 0.01) 100%);*/
  background:radial-gradient(30px 30px at 20px 20px, rgba(0, 196, 255, 255) 50%, rgba(0, 22, 155, 118.01) 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue